enum WorkspaceProjectImpactFrameworkComponentLeakageType {
  'cause' = 'cause',
  'reduce' = 'reduce',
}

export default WorkspaceProjectImpactFrameworkComponentLeakageType
